var exports = {
  "iU": "Message.module__message___Mm02Mk",
  "Ph": "Message.module__messagePreviewSpacing___Mm02Mk",
  "IL": "Message.module__messagePreview___Mm02Mk",
  "uK": "Message.module__focusRingAnchor___Mm02Mk",
  "J8": "Message.module__messageCompact___Mm02Mk",
  "Xo": "Message.module__messageHovered___Mm02Mk",
  "L8": "Message.module__messageMentioned___Mm02Mk",
  "m6": "Message.module__messageReplying___Mm02Mk",
  "O6": "Message.module__messageHighlight___Mm02Mk",
  "lY": "Message.module__contextMenuActive___Mm02Mk",
  "Bc": "Message.module__mobileLayout___Mm02Mk",
  "p2": "Message.module__messageLongPress___Mm02Mk",
  "Uw": "Message.module__messageGrouped___Mm02Mk",
  "kT": "Message.module__messageEditing___Mm02Mk",
  "E4": "Message.module__messageSent___Mm02Mk",
  "mr": "Message.module__messageSending___Mm02Mk",
  "b$": "Message.module__messageFailed___Mm02Mk",
  "RZ": "Message.module__failedFooter___Mm02Mk",
  "Iu": "Message.module__failedFooterMessage___Mm02Mk",
  "bg": "Message.module__failedFooterLabel___Mm02Mk",
  "OZ": "Message.module__failedFooterIcon___Mm02Mk",
  "dv": "Message.module__failedRetryIcon___Mm02Mk",
  "QW": "Message.module__failedRetryButton___Mm02Mk",
  "q5": "Message.module__messageGutterLeft___Mm02Mk",
  "ZN": "Message.module__messageGutterRight___Mm02Mk",
  "$7": "Message.module__messageAvatar___Mm02Mk",
  "CW": "Message.module__messageNoText___Mm02Mk",
  "U7": "Message.module__messageContent___Mm02Mk",
  "rO": "Message.module__messageAuthorInfo___Mm02Mk",
  "xW": "Message.module__jumpHeading___Mm02Mk",
  "RO": "Message.module__jumpHeadingButton___Mm02Mk",
  "dw": "Message.module__messageAuthorRow___Mm02Mk",
  "AY": "Message.module__messageAuthorPart___Mm02Mk",
  "x": "Message.module__userTagOffset___Mm02Mk",
  "oL": "Message.module__messageTimestamp___Mm02Mk",
  "BK": "Message.module__authorDashSeparator___Mm02Mk",
  "um": "Message.module__messageUsername___Mm02Mk",
  "Lo": "Message.module__messageText___Mm02Mk",
  "L5": "Message.module__messageTimestampCompact___Mm02Mk",
  "tQ": "Message.module__compactAuthorPrefix___Mm02Mk",
  "U6": "Message.module__copyOnly___Mm02Mk",
  "Mz": "Message.module__compactInlineContent___Mm02Mk",
  "aM": "Message.module__systemMessageContent___Mm02Mk",
  "vd": "Message.module__messageRoleIcon___Mm02Mk",
  "vp": "Message.module__contextMenuUnderline___Mm02Mk",
  "aE": "Message.module__messageTimeoutIndicator___Mm02Mk",
  "t4": "Message.module__textSeparator___Mm02Mk",
  "KL": "Message.module__messageTimestampHover___Mm02Mk",
  "jh": "Message.module__messageTimestampCompactHover___Mm02Mk",
  "iZ": "Message.module__messageAvatarCompact___Mm02Mk",
  "kq": "Message.module__compactContentWrapper___Mm02Mk",
  "xv": "Message.module__hoverAction___Mm02Mk",
  "kL": "Message.module__container___Mm02Mk",
  "tI": "Message.module__repliedMessage___Mm02Mk",
  "_T": "Message.module__repliedMessageCompact___Mm02Mk",
  "$y": "Message.module__repliedTextPreview___Mm02Mk",
  "NL": "Message.module__repliedAvatar___Mm02Mk",
  "a3": "Message.module__repliedIconContainer___Mm02Mk",
  "Pq": "Message.module__repliedIcon___Mm02Mk",
  "EK": "Message.module__repliedUsername___Mm02Mk",
  "IQ": "Message.module__repliedItalic___Mm02Mk",
  "t": "Message.module__unstyled___Mm02Mk",
  "Io": "Message.module__repliedTextContent___Mm02Mk",
  "c": "Message.module__systemMessageFollowsSystem___Mm02Mk",
  "Hj": "Message.module__systemMessageIconWrapper___Mm02Mk",
  "Po": "Message.module__systemMessageIconCompact___Mm02Mk",
  "jJ": "Message.module__systemMessageTimestamp___Mm02Mk",
  "rc": "Message.module__systemMessageContentWrapper___Mm02Mk",
  "V_": "Message.module__systemMessageCompactContent___Mm02Mk",
  "Gq": "Message.module__systemMessageIconSvg___Mm02Mk",
  "hr": "Message.module__systemMessageLink___Mm02Mk",
  "ll": "Message.module__userTagCompact___Mm02Mk",
  "Qh": "Message.module__messageAuthorName___Mm02Mk",
  "O4": "Message.module__editedTimestamp___Mm02Mk",
  "k8": "Message.module__editedLabel___Mm02Mk",
  "zX": "Message.module__typingContainer___Mm02Mk",
  "Y9": "Message.module__typingCluster___Mm02Mk",
  "RL": "Message.module__typingIndicator___Mm02Mk",
  "Kl": "Message.module__typingAvatarContainer___Mm02Mk",
  "tY": "Message.module__typingText___Mm02Mk",
  "AZ": "Message.module__typingClusterComposerStatus___Mm02Mk",
  "am": "Message.module__compactContentNoPrefix___Mm02Mk",
  "Ys": "Message.module__compactBody___Mm02Mk",
  "Ac": "Message.module__unknownMessageCompactContent___Mm02Mk",
  "qU": "Message.module__unknownMessageWarning___Mm02Mk",
  "NG": "Message.module__keyboardFocused___Mm02Mk",
  "an": "Message.module__messageClientSystem___Mm02Mk",
  "og": "Message.module__systemMessageContainer___Mm02Mk",
  "Is": "Message.module__systemMessageIcon___Mm02Mk",
  "ry": "Message.module__mediaFocusRing___Mm02Mk",
  "xS": "Message.module__systemMessageDismissButton___Mm02Mk",
  "Eu": "Message.module__silentMessageIcon___Mm02Mk",
};

module.exports = exports;
